import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './css/Videocategories.module.css';
import DocumentaryCard from './DocumentaryCard';
import { useVideosByCategory } from '../../hooks/useVideosHooks';

const Videoscategories = ({title}) => {
  const navigate = useNavigate();
  
  const handleNavigation = (e) => {
    e.preventDefault();
    navigate(`/video/category/${title}`);
  };
  
  const { videos, isLoading, error } = useVideosByCategory(title, 1, 8);
  
  // Determine if we should show the "View all" button
  const showViewAllButton = videos && videos.length >= 5;
  
  // Use window width to determine how many videos to show
  const [displayCount, setDisplayCount] = React.useState(8);
  
  React.useEffect(() => {
    const handleResize = () => {
      // Show 4 videos on mobile, 8 on larger screens
      setDisplayCount(window.innerWidth <= 768 ? 4 : 8);
    };
    
    // Set initial count
    handleResize();
    
    // Add event listener
    window.addEventListener('resize', handleResize);
    
    // Clean up
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  return (
    <div className={styles.documentarySection}>
      <div className={styles.sectionHeader}>
        <h2>{title} Videos</h2>
        {showViewAllButton && (
          <a href="/DocumentaryFullPage" className={styles.viewAll} onClick={handleNavigation}>
            View all &gt;
          </a>
        )}
      </div>
      
      {isLoading ? (
        <div className={styles.loadingState}>Loading documentaries...</div>
      ) : error ? (
        <div className={styles.errorState}>Error loading documentaries: {error.message}</div>
      ) : videos && videos.length > 0 ? (
        <div className={styles.gridContainer}>
          {videos.slice(0, displayCount).map((doc) => (
            <div key={doc.id} className={styles.gridItem}>
              <DocumentaryCard documentary={formatDocumentaryData(doc)} />
            </div>
          ))}
        </div>
      ) : (
        <div className={styles.emptyState}>No documentaries available</div>
      )}
    </div>
  );
};

// Helper function to format API response data to match the expected format for DocumentaryCard
const formatDocumentaryData = (apiDoc) => ({
  id: apiDoc.id,
  title: apiDoc.title,
  slug: apiDoc.slug,
  description: apiDoc.description,
  computer_image_url: apiDoc.computer_image_url || '/fallback-image.jpg',
  mobile_image_url: apiDoc.mobile_image_url,
  author_name: apiDoc.author_name,
  duration: formatDuration(apiDoc.duration),
  category: apiDoc.category,
  video_url: apiDoc.video_url,
});

// Helper function to format duration from seconds to MM:SS
const formatDuration = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
};
  
export default Videoscategories;